<template>
  <div>
    <Loader v-if="loader.data" />
    <div class="container-fluid px-0" v-cloak>
      <div class="d-flex">
        
     
        <div class="page__content">
          <Nav
            @show-contrast-view="toggleShowContrast"
            @show-regular-font-view="toggleRegularFontView"
            @show-middle-font-view="toggleMiddleFontView"
            @show-big-font-view="toggleBigFontView"
          />
          <div
            v-show="openModalInvitation"
            class="back back--invitationDesktop"
            @click="toggleModalInvitation(false)"
          >
            <span class="d-none d-lg-block">Powrót do strony</span>
             <span class="d-block d-lg-none">X</span>
          </div>
          <Content />
        </div>
        <Form />
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./Content.vue";
import Nav from "./elements/Nav.vue";
import Form from "./Form.vue";
import Loader from "./elements/Loader.vue";

export default {
  name: "Page",

  data() {
    return {
      formAmountSubValue: 30,
      formAmountOneValue: 210,
      openModalInvitation: false,
      openModalPayment: false,
      contrastView: false,
      fontRegularView: true,
      fontMiddleView: false,
      fontBigView: false,
      mainPage: true,
      showAnimationFooter: false,
      showAnimationOther: false,
      subscription: false,
      oneTimePayment: false,
    };
  },
  created() {
    this.$root.$on("setSubscription", (e) => {
      this.setSubscription(e);
    });
    this.$root.$on("setOneTimePayment", (e) => {
      this.setOneTimePayment(e);
    });
    this.$root.$on("formAmountSubDown", () => {
      this.formAmountSubDown();
    });
    this.$root.$on("formAmountSubUp", () => {
      this.formAmountSubUp();
    });
    this.$root.$on("setFormAmountSubValue", (e) => {
      this.setFormAmountSubValue(e);
    });
      this.$root.$on("formAmountOneDown", () => {
      this.formAmountOneDown();
    });
    this.$root.$on("formAmountOneUp", () => {
      this.formAmountOneUp();
    });
    this.$root.$on("setFormAmountOneValue", (e) => {
      this.setFormAmountOneValue(e);
    });
    this.$root.$on("toggleModalInvitation", (e) => {
      this.toggleModalInvitation(e);
    });
    this.$root.$on("toggleModalPayment", (e) => {
      this.toggleModalPayment(e);
    });
  },
  provide() {
    const appData = {
      oneTimePayment: this.oneTimePayment,
      subscription: this.subscription,
      formAmountOneValue: this.formAmountOneValue,
      formAmountSubValue: this.formAmountSubValue,
      openModalInvitation: this.openModalInvitation,
      openModalPayment: this.openModalPayment,
    };

    Object.defineProperty(appData, "oneTimePayment", {
      get: () => this.oneTimePayment,
    });
    Object.defineProperty(appData, "subscription", {
      get: () => this.subscription,
    });
    Object.defineProperty(appData, "formAmountSubValue", {
      enumerable: true,
      get: () => this.formAmountSubValue,
    });
    Object.defineProperty(appData, "formAmountOneValue", {
      enumerable: true,
      get: () => this.formAmountOneValue,
    });
    Object.defineProperty(appData, "openModalInvitation", {
      get: () => this.openModalInvitation,
    });
    Object.defineProperty(appData, "openModalPayment", {
      get: () => this.openModalPayment,
    });

    return {
      updateCheckoutInfo: this.updateCheckoutInfo,
      appData,
    };
  },
  components: {
    Loader,
    Content,
    Nav,
    Form,
  },
      inject: ["loader"],
  methods: {
    formAmountSubUp() {
      if (this.formAmountSubValue < 4998) {
        this.formAmountSubValue = this.formAmountSubValue + 5;
      } else {
        this.formAmountSubValue = 4999;
      }
    },
    formAmountSubDown() {
      if (this.formAmountSubValue > 30) {
        this.formAmountSubValue = this.formAmountSubValue - 5;
      } else {
        this.formAmountSubValue = 30;
      }
    },
    setSubscription(val) {
      this.subscription = val;
    },
    setOneTimePayment(val) {
      this.oneTimePayment = val;
    },
    setFormAmountSubValue(val) {
      this.formAmountSubValue = parseInt(val, 10);
    },
    formAmountOneUp() {
      if (this.formAmountOneValue < 4998) {
        this.formAmountOneValue = this.formAmountOneValue + 5;
      } else {
        this.formAmountOneValue = 4999;
      }
    },
    formAmountOneDown() {
      if (this.formAmountOneValue >210) {
        this.formAmountOneValue = this.formAmountOneValue - 5;
      } else {
        this.formAmountOneValue = 210;
      }
    },
    setFormAmountOneValue(val) {
      this.formAmountOneValue = parseInt(val, 10);
    },
    toggleModalInvitation(val) {
      //todo remove
      this.openModalInvitation = val;
    },
    toggleModalPayment(val) {
      this.openModalPayment = val;
    },
    toggleShowContrast: function () {
      this.contrastView = !this.contrastView;
    },
    toggleRegularFontView: function () {
      this.fontRegularView = !this.fontRegularView;
    },
    toggleMiddleFontView: function () {
      this.fontMiddleView = !this.fontMiddleView;
    },
    toggleBigFontView: function () {
      this.fontBigView = !this.fontBigView;
    },
  },

  watch: {
    contrastView: function () {
      const el = document.body;
      if (this.contrastView) {
        el.classList.add("body--contrast");
      } else {
        el.classList.remove("body--contrast");
      }
    },

    fontRegularView: function () {
      const el = document.getElementsByTagName("html")[0];
      el.classList.remove("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontMiddleView: function () {
      const el = document.getElementsByTagName("html")[0];

      el.classList.add("body--middle-font");
      el.classList.remove("body--big-font");
    },
    fontBigView: function () {
      const el = document.getElementsByTagName("html")[0];

      el.classList.remove("body--middle-font");
      el.classList.add("body--big-font");
    },
  },
};
</script>
